import {
  MdSupportAgent,
  MdDevices,
  MdWorkspacePremium,
  MdStorage,
  MdDns,
  MdCloud,
  MdBackup,
  MdMonitor,
  MdTipsAndUpdates,
} from "react-icons/md";

const servicesData = {
  "helpdesk-support": {
    title: "IT Helpdesk Support",
    desc: "Tier 1–3 support for hardware, software, network, and devices with remote & onsite assistance.",
    icon: <MdSupportAgent className="w-12 h-12 text-white" />,
    banner: "/assets/services/helpdesk-banner.jpg",
    features: [
      "24/7 remote support",
      "Onsite assistance",
      "Hardware troubleshooting",
      "Software installation",
      "Ticket management",
      "Priority escalation",
      "User onboarding",
      "Knowledge base access",
      "Email support",
      "Remote diagnostics",
    ],
    images: [
      "/assets/services/helpdesk1.jpg",
      "/assets/services/helpdesk2.jpg",
    ],
  },
  "device-management": {
    title: "Device & Endpoint Management",
    desc: "Setup, configuration, and management of laptops, mobile devices, and Chrome devices with MDM.",
    icon: <MdDevices className="w-12 h-12 text-white" />,
    banner: "/assets/services/device-banner.jpg",
    features: [
      "Device enrollment",
      "Remote configuration",
      "Security compliance",
      "Patch management",
      "Asset tracking",
      "Lifecycle management",
      "Device inventory reporting",
      "Remote wipe & recovery",
      "OS updates",
      "Peripheral setup",
    ],
    images: [
      "/assets/services/device1.jpg",
      "/assets/services/device2.jpg",
    ],
  },
  "productivity-support": {
    title: "End-User Productivity Support",
    desc: "Assist users with software installations, configuration, troubleshooting, and Office 365 apps.",
    icon: <MdWorkspacePremium className="w-12 h-12 text-white" />,
    banner: "/assets/services/productivity-banner.jpg",
    features: [
      "Workspace configuration",
      "Team collaboration setup",
      "Cloud sync & backup",
      "Access management",
      "Productivity monitoring",
      "Custom dashboards",
      "Software deployment",
      "User permissions management",
      "Workspace security",
      "Workflow automation",
    ],
    images: [
      "/assets/services/productivity1.jpg",
      "/assets/services/productivity2.jpg",
    ],
  },
  "server-virtualization": {
    title: "Server & Virtualization Services",
    desc: "Deploy and manage servers, VMware ESXi & vCenter, Hyper-V, Linux/Windows servers, and virtual machines.",
    icon: <MdStorage className="w-12 h-12 text-white" />,
    banner: "/assets/services/server-banner.jpg",
    features: [
      "NAS/SAN setup",
      "Cloud storage integration",
      "Data replication",
      "Backup scheduling",
      "Storage monitoring",
      "Recovery planning",
      "Performance optimization",
      "Encryption & security",
      "Storage tiering",
      "Capacity planning",
    ],
    images: [
      "/assets/services/server1.jpg",
      "/assets/services/server2.jpg",
    ],
  },
  "network-security": {
    title: "Network & Security Solutions",
    desc: "Configure firewalls, VPNs, secure network access, monitoring, and micro-segmentation to protect IT environments.",
    icon: <MdDns className="w-12 h-12 text-white" />,
    banner: "/assets/services/network-banner.jpg",
    features: [
      "Network monitoring",
      "DNS configuration",
      "Firewall management",
      "Bandwidth optimization",
      "Security audits",
      "VPN setup",
      "Router/switch configuration",
      "Network segmentation",
      "Traffic analysis",
      "Load balancing",
    ],
    images: [
      "/assets/services/network1.jpg",
      "/assets/services/network2.jpg",
    ],
  },
  "cloud-m365": {
    title: "Cloud & Microsoft 365 Services",
    desc: "Manage Microsoft 365, Azure AD, SharePoint, Teams, OneDrive, and implement secure access policies.",
    icon: <MdCloud className="w-12 h-12 text-white" />,
    banner: "/assets/services/cloud-banner.jpg",
    features: [
      "Cloud deployment",
      "Virtual machines",
      "Backup & recovery",
      "Security & compliance",
      "Monitoring & alerts",
      "Cost optimization",
      "Scaling & load balancing",
      "API integration",
      "Container management",
      "Cloud migration",
    ],
    images: [
      "/assets/services/cloud1.jpg",
      "/assets/services/cloud2.jpg",
    ],
  },
  "backup-recovery": {
    title: "Backup & Disaster Recovery",
    desc: "Implement Veeam, Zerto, and other backup solutions with automated monitoring, testing, and reporting.",
    icon: <MdBackup className="w-12 h-12 text-white" />,
    banner: "/assets/services/backup-banner.jpg",
    features: [
      "Automated backups",
      "Cloud backup integration",
      "Recovery testing",
      "Retention policies",
      "Redundancy setup",
      "Disaster recovery planning",
      "Version control backups",
      "Failover setup",
      "Data archiving",
      "Backup reporting",
    ],
    images: [
      "/assets/services/backup1.jpg",
      "/assets/services/backup2.jpg",
    ],
  },
  "monitoring-reporting": {
    title: "Monitoring & Reporting",
    desc: "Proactively monitor servers, network, Active Directory, and backups; provide performance reports and alerts.",
    icon: <MdMonitor className="w-12 h-12 text-white" />,
    banner: "/assets/services/monitoring-banner.jpg",
    features: [
      "Server monitoring",
      "Network monitoring",
      "Application performance",
      "Custom dashboards",
      "Alerts & notifications",
      "Detailed reporting",
      "Health checks",
      "Log management",
      "SLA tracking",
      "Resource optimization",
    ],
    images: [
      "/assets/services/monitoring1.jpg",
      "/assets/services/monitoring2.jpg",
    ],
  },
  "it-consulting": {
    title: "IT Consulting & Managed Services",
    desc: "Design scalable IT infrastructure, perform security audits, ensure compliance, and provide strategic guidance.",
    icon: <MdTipsAndUpdates className="w-12 h-12 text-white" />,
    banner: "/assets/services/consulting-banner.jpg",
    features: [
      "Weekly IT tips",
      "System updates",
      "Security alerts",
      "Performance optimization",
      "Best practices",
      "Knowledge sharing",
      "Patch notifications",
      "New technology recommendations",
      "IT newsletters",
      "Process improvements",
    ],
    images: [
      "/assets/services/consulting1.jpg",
      "/assets/services/consulting2.jpg",
    ],
  },
};

export default servicesData;
